import React from "react"

class ActiveItems extends React.Component {
  constructor(props) {
    super(props)
    const { activeItems, appNumber, enableEdit } = this.props

    this.state = {
      editing: false,
      activeItems: activeItems || "",
      appNumber: appNumber,
      enableEdit: enableEdit,
      fullText: false
    }

    this.edit           = this.edit.bind(this)
    this.close          = this.close.bind(this)
    this.saveInput      = this.saveInput.bind(this)
    this.toggleFullText = this.toggleFullText.bind(this)
  }

  edit() {
    this.setState({ editing: !this.state.editing })
  }

  toggleFullText() {
    this.setState({ fullText: !this.state.fullText })
  }

  close() {
    this.props.updateLoanState(this.state.appNumber, { active_items: this.textInput.value })
    this.setState({ editing: false })
    fetch(`/admin/loans/${this.state.appNumber}/update_pipeline`, {
      method: 'PUT',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.props.csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: `{ "loan": { "note_to_self": "${this.textInput.value}" } }`,
      credentials: 'same-origin'
    })
  }

  saveInput() {
    this.setState({ activeItems: this.textInput.value })
  }
  
  render() {
    const { activeItems, editing, fullText } = this.state
    const enableShowTextButton = !editing && activeItems.length >= 80;
    const truncatedText = fullText || activeItems.length <= 80 
                                    ? activeItems
                                    : activeItems.slice(0, 80).concat('...')
    return(
      <div>
        <div className={`readme ${editing ? 'hidden' : null}`}>
          <span>
            {truncatedText || "Add Action Items"}
          </span>
          <br/>
        </div>
        <textarea
          rows="3"
          ref={input => { this.textInput = input }}
          onBlur={this.close}
          onChange={this.saveInput}
          className={editing ? null : 'hidden'}
          placeholder="Add Action Items"
          value={activeItems} />
        <input
          type="button"
          value="Read more"
          className={`${(!fullText && enableShowTextButton) ? null : 'hidden'} link-style`}
          onClick={this.toggleFullText}>
        </input>
        <input
          type="button"
          value="Read less"
          className={`${(fullText && enableShowTextButton) ? null : 'hidden'} link-style`}
          onClick={this.toggleFullText}>
        </input>
        <br/>
        <span>
          <button className='link-style' type='reset' onClick={editing ? this.close : this.edit}>
            <i className="fa fa-pencil"/> {editing ? 'Save' : 'Edit'}
          </button>
        </span>
      </div>
    )
  }
}

export default ActiveItems;
